// Catálogo de mapas base + tema de rutas asociado.
// Todos sin necesidad de API key. Atribución requerida por cada proveedor.

export const BASEMAPS = {
  topo: {
    label: 'Topográfico',
    description: 'OpenTopoMap · ideal para senderismo',
    tiles: [
      'https://a.tile.opentopomap.org/{z}/{x}/{y}.png',
      'https://b.tile.opentopomap.org/{z}/{x}/{y}.png',
      'https://c.tile.opentopomap.org/{z}/{x}/{y}.png',
    ],
    maxzoom: 17,
    attribution: 'Map data © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> · SRTM | Map style: © <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)',
    trackTheme: {
      color: '#ff3d9a',
      zoneColor: '#2bb36a',
      outline: '#000000',
      width: 3,
      outlineWidth: 5,
      outlineOpacity: 0.35,
      opacity: 0.75,
      blur: 0,
    },
  },

  cyclosm: {
    label: 'CyclOSM',
    description: 'Senderos y rutas ciclistas resaltadas',
    tiles: [
      'https://a.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
      'https://b.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
      'https://c.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    ],
    maxzoom: 20,
    attribution: 'Map: © <a href="https://www.cyclosm.org">CyclOSM</a> · Data: © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    trackTheme: {
      color: '#ff3d9a',
      zoneColor: '#2bb36a',
      outline: '#000000',
      width: 3,
      outlineWidth: 5,
      outlineOpacity: 0.4,
      opacity: 0.8,
      blur: 0,
    },
  },

  satellite: {
    label: 'Satélite',
    description: 'Esri World Imagery',
    tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
    maxzoom: 19,
    attribution: 'Tiles © Esri · Sources: Esri, Maxar, Earthstar Geographics',
    trackTheme: {
      color: '#ffc94b',
      zoneColor: '#34d1c4',
      outline: '#000000',
      width: 3,
      outlineWidth: 5,
      outlineOpacity: 0.55,
      opacity: 0.9,
      blur: 0,
    },
  },

  light: {
    label: 'Claro',
    description: 'Minimal, las rutas brillan',
    tiles: [
      'https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      'https://b.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      'https://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
      'https://d.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    ],
    maxzoom: 20,
    attribution: '© <a href="https://carto.com/">CARTO</a> · © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    trackTheme: {
      color: '#ff3d9a',
      zoneColor: '#2bb36a',
      outline: '#ffffff',
      width: 2.5,
      outlineWidth: 4,
      outlineOpacity: 0.7,
      opacity: 0.9,
      blur: 0,
    },
  },

  dark: {
    label: 'Oscuro',
    description: 'Estilo nocturno con neón suave',
    tiles: [
      'https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
      'https://b.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
      'https://c.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
      'https://d.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
    ],
    maxzoom: 20,
    attribution: '© <a href="https://carto.com/">CARTO</a> · © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    trackTheme: {
      color: '#34d1c4',
      zoneColor: '#ffc94b',
      outline: '#34d1c4',
      width: 2,
      outlineWidth: 6,
      outlineOpacity: 0.25,
      opacity: 0.95,
      blur: 1.2,
    },
  },

  blueprint: {
    label: 'Blueprint',
    description: 'Plano técnico azul',
    background: '#0c2237',
    overlay: {
      // Líneas blancas suaves de coastline para dar contexto sin saturar
      tiles: [
        'https://a.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png',
        'https://b.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}.png',
      ],
      opacity: 0.18,
    },
    attribution: '© <a href="https://carto.com/">CARTO</a> labels · © OpenStreetMap',
    trackTheme: {
      color: '#ffffff',
      zoneColor: '#7dd3fc',
      outline: '#7dd3fc',
      width: 1.6,
      outlineWidth: 4,
      outlineOpacity: 0.18,
      opacity: 0.95,
      blur: 0.4,
    },
  },

  constellation: {
    label: 'Constelación',
    description: 'Sin mapa · solo tus rutas como estrellas',
    background: '#08080d',
    attribution: '© WikiTot',
    trackTheme: {
      color: '#ff3d9a',
      zoneColor: '#34d1c4',
      outline: '#ff3d9a',
      width: 1.8,
      outlineWidth: 10,
      outlineOpacity: 0.18,
      opacity: 1,
      blur: 2.5,
    },
  },
};

export const DEFAULT_BASEMAP = 'satellite';
export const BASEMAP_ORDER = ['topo', 'cyclosm', 'satellite', 'light', 'dark', 'blueprint', 'constellation'];
